import prioritizedUseQueryFuturesHook from './prioritizedUseQueryFuturesHook'

const usePrefetchedQueryFutures = prioritizedUseQueryFuturesHook(0.5)

export default usePrefetchedQueryFutures
